import { FormControlLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { BoxFC } from "components/BoxCustom";
import React, { useCallback } from "react";
import { textFieldProp } from "./constant";
import SaveDataButton from "./SaveDataButton";

const SendEmailContent = ({ sendEmailData, setSendEmailData }) => {

  const sendEmailDataProps = useCallback((name) => ({
    ...textFieldProp,
    name: name,
    value: sendEmailData[name],
    onChange: (e) => setSendEmailData(o => ({ ...o, [name]: e.target.value }))
  }), [sendEmailData, setSendEmailData])
  return (
    <BoxFC>
      <Typography variant="h6">ข้อมูลการส่งอีเมล</Typography>
      <BoxFC pl={2} width={500}>
        <Typography fontWeight="bold" width={100}>ประเภท</Typography>
        <RadioGroup name='MailServiceType' sx={{ pl: 1, mt: -2 }} value={sendEmailData.MailServiceType || "GMAIL"}
          onChange={(e) => { setSendEmailData((oldState) => ({ ...oldState, MailServiceType: e.target.value })) }}>
          <FormControlLabel value={"GMAIL"} control={<Radio />} label="GMAIL" />
          <FormControlLabel value={"MS365"} control={<Radio />} label="MICROSOFT 365 App Password" />
          <FormControlLabel value={"MS365OAuth2"} control={<Radio />} label="MICROSOFT 365 OAuth2" />
        </RadioGroup>
        <TextField {...sendEmailDataProps("Email")} label="อีเมล" />
        {["GMAIL", "MS365"].includes(sendEmailData.MailServiceType) ?
          <TextField {...sendEmailDataProps("Pass")} label="พาสเวิร์ด" /> : null
        }
        {sendEmailData.MailServiceType === "MS365OAuth2" ?
          <BoxFC>
            <TextField {...sendEmailDataProps("TenantId")} label="Tenant ID" />
            <TextField {...sendEmailDataProps("ClientId")} label="Client ID" />
            <TextField {...sendEmailDataProps("ClientSecret")} label="Client Secret" />
          </BoxFC> : null
        }
        {/* <TextField {...sendEmailDataProps("Cc")} label="Cc" />
        <TextField {...sendEmailDataProps("Bcc")} label="Bcc" />
        <TextField {...sendEmailDataProps("ReplyTo")} label="Reply To" /> */}
        <TextField {...sendEmailDataProps("Ending")} label="คำลงท้ายอีเมล" multiline rows={3} />
        <TextField {...sendEmailDataProps("InvPreText")} label="ข้อความ Invoice" />
      </BoxFC>
      <SaveDataButton sx={{ width: 150 }} name="SendEmailData" data={sendEmailData} />
    </BoxFC>
  )
}

export default React.memo(SendEmailContent)